import { SearchFormState } from '../reducers';

export const isOfferHotels = (state: SearchFormState) => state.offerHotels;
